// Thin lines made more visible 1px
const strokeCorrection = (strokeWidth: number | null | undefined, viewScale: number): number => {
  if (strokeWidth) {
    strokeWidth = (
      strokeWidth * viewScale > 1 ?
        strokeWidth :
        1 / viewScale
    );
  } else {
    strokeWidth = 1;
  }
  return strokeWidth;
}

// Thin hitpoints a given pixel
const hitStrokeCorrection = (hitStrokeWidth: number | null | undefined, strokeWidth: number | null | undefined, viewScale: number): number => {
  hitStrokeWidth = (hitStrokeWidth && Math.max(hitStrokeWidth, strokeWidth ?? 0)) || (strokeWidth ?? 0)
  if (hitStrokeWidth) {
    hitStrokeWidth = (
      hitStrokeWidth * viewScale > 8 ?
        hitStrokeWidth :
        8 / viewScale
    );
  } else {
    hitStrokeWidth = 8 / viewScale;
  }
  return hitStrokeWidth;
}


export { hitStrokeCorrection, strokeCorrection }